module.exports = __webpack_public_path__ + "media/images/bg-mv-bride-ea84a82de51985d5b8c0a09bf60d1c72.png";